import React, { useState, useEffect } from 'react';
import { faqData as mockFaqData } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FAQ = () => {
  const [faqs, setFaqs] = useState(mockFaqData);

  // Fetch FAQs from API
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch(`${API_URL}/api/faqs`);
        if (response.ok) {
          const data = await response.json();
          if (data.faqs && data.faqs.length > 0) {
            setFaqs(data.faqs);
          }
        }
      } catch (error) {
        console.log('Using mock FAQ data');
      }
    };
    fetchFaqs();
  }, []);

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-black border-2 border-cyan rounded-3xl mb-8">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-xl sm:text-[3.2vw] md:text-[3vw] lg:text-[2.85vw] text-center mb-16 text-gold font-semibold sm:whitespace-nowrap" style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}>
          Frequently Asked Questions
        </h2>
        
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-black/40 border border-white/10 rounded-xl px-6 hover:border-white/30 hover:bg-black/60 transition-all duration-300 data-[state=open]:border-gold/50 data-[state=open]:bg-black/70"
            >
              <AccordionTrigger 
                className="text-left text-base sm:text-lg text-white font-medium py-5 hover:no-underline hover:text-gold transition-colors" 
                style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-silver pb-5 leading-relaxed text-sm sm:text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
